import TrapDataOverview from './TrapDataOverview'
import enhance from './TrapDataOverview.enhancer'

export default enhance(TrapDataOverview)

export const trapColumns = [
  {
    width: 50, field: 'selectable', selectable: true, format: 'locate',
  },
  {
    width: 300, label: 'Trap Name', field: 'trapName', format: 'trapName'
  },
  {
    width: 200, 
    format: 'fullDate',
    align: 'flex-end',
    field: 'lastSynced',
    label: 'Last Synced', 
    helpText: 'The date when the trap was last synced and data collected via the Goodnature Chirp app'
  },
  {
    width: 150, label: 'Kills', field: 'totalKills', align: 'flex-end',
  },
  {
    width: 150, 
    align: 'flex-end',
    format: 'percentage',
    field: 'operatingRate',
    label: 'Operating Rate',
    helpText: 'Percentage of time trap had CO2 and Paste to perform kills'
  }
]



// WEBPACK FOOTER //
// ./src/containers/traps/TrapDataOverview/index.js